import React, { useState } from 'react';
import DetachModal from './components/modals/DetachModal';

export function useContentPropertyDetachModal({
    onDetach,
    selectedCount,
}: {
    onDetach: () => void;
    selectedCount: number;
}) {
    const [isOpen, setIsModalOpen] = useState(false);

    const renderContentPropertyDetachModal = () => (
        <DetachModal
            isOpen={isOpen}
            onClose={() => setIsModalOpen(false)}
            onDetach={onDetach}
            selectedCount={selectedCount}
        />
    );

    return {
        renderContentPropertyDetachModal,
        setIsContentPropertyDetachModalOpen: setIsModalOpen,
    };
}
